import type { GetNotificationById200BasicInfoAllOf } from './getNotificationById200BasicInfoAllOf';
import type { GetNotificationById200BasicInfoAllOfTwo } from './getNotificationById200BasicInfoAllOfTwo';

export type GetNotificationById200BasicInfo = GetNotificationById200BasicInfoAllOf & GetNotificationById200BasicInfoAllOfTwo;
